import React from "react";
import { useTranslation } from "react-i18next";

import { ReportIcon } from "@common/assets/reportIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function SubmitReportButton({ submitReport }: Props) {
  const { t } = useTranslation();

  return (
    <button className={styles.submitReportButton} onClick={submitReport}>
      <ReportIcon className={styles.icon} />
      <p>{t("projectPage.synthesisPage.submitReport")}</p>
    </button>
  );
}

export { SubmitReportButton };
